<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange" @selection-change="handleSelectionChange"
        @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menu">
          <el-button type="success" icon="el-icon-view" size="small" plain @click.stop="toView(scope.row)">查看</el-button>
          <el-button type="primary" icon="el-icon-sold-out" size="small" v-if="scope.row.status == 'WAIT_SHIPPED'" plain
            @click.stop="selectDistributor(scope.row)">配送</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" plain
            @click.stop="handleDel(scope.row)">删除</el-button>
        </template>
      </avue-crud>
      <!-- 选择配送商弹窗，下拉选择配送商 -->
      <el-dialog title="选择配送商" :visible.sync="showDialog" width="30%">
        <el-form :model="distributor" label-width="80px" ref="distributor">
          <el-form-item label="配送商">
            <el-select v-model="distributor.distributorId" placeholder="请选择配送商">
              <el-option v-for="item in distributors" :key="item.distributorId" :label="item.distributorName" :value="item.distributorId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDialog = false">取 消</el-button>
          <el-button type="primary" @click="handleSave">确 定</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { agentOrderManagementOption } from "@/const/salesCloud/agentOrderManagementOption";
import { findProvider } from "@/api/salesCloud/productOrderDetailsMerchant"
import {
  findOrderList,
  deleteOrder,
  selectDelivery,
  findOrderListExcel
} from "@/api/salesCloud/agentOrderManagement";
import { resolveUrlPath } from "@/util/util";

export default {
  name: "agentOrderManagement",
  components: {},
  data() {
    return {
      tableOption: agentOrderManagementOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      showDialog: false,
      tabelObj: {},
      downloadData: {},
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      distributor: {},
      distributors: [],
      goods: {},
      goodsList: [],
      tableData1: [],
      constitutes: [],
      dataSku1: []
    };
  },
  created() {
    this.handleList();
    findProvider().then((res) => {
      let data = JSON.parse(res.data);
      this.distributors = data.rows;

    })
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      // console.log(params);
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startTime_endTime &&
        undefined != params.startTime_endTime &&
        "" != params.startTime_endTime
      ) {
        params.startTime = params.startTime_endTime[0];
        params.endTime = params.startTime_endTime[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      this.downloadData = params;
      findOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * 
     * @param {id} row 
     * @dscription 查看详情
     */
    toView(row) {
      let obj = {
        label: "查看订单详情",
        value: "agentOrderManagement/view"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: {
          id: row.id
        }
      });
    },
    /**
     * @description 配送
     */
    selectDistributor(row) {
      // 弹窗选择配送商
      // console.log(row);
      this.tabelObj = row;
      this.showDialog = true;
    },
    /**
     * @description 保存
     */
    handleSave() {
      this.$refs["distributor"].validate(valid => {
        if (valid) {
          // console.log(this.distributor,valid);
          let params = {
            providerId: this.distributor.distributorId,
            orderId: this.tabelObj.id,
            size:10000
          };
          // console.log(params);
          this.$confirm(`是否确认配送?`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.showDialog = false;
              selectDelivery(params).then(res => {
                if (res.code == "200") {
                  this.$message({
                    showClose: true,
                    message: "分配成功",
                    type: "success"
                  });
                  this.handleList();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: "error"
                  });
                }
              });
            })
            .catch(() => {
            });
        } else {
          return false;
        }
      });
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findOrderList(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
    handleSelectionChange(val) {
      let ids = val.map(item => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {
      // console.log(row);
      let ids = "";
      ids = this.ids;
      if (row) {
        ids = row.id;
        // console.log(ids);
      } else {
        if (this.ids) {
          // console.log(this.ids);
        } else {
          this.$message({
            showClose: true,
            message: "未选择任何数据",
            type: "error"
          });
          return
        }
      }
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          /* let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
              ids.push(row.id)
          } */
          // console.log(ids, 9999);
          deleteOrder(ids).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }

          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
        .catch(() => {
        });
    },
    clean() {
      this.distributor = {};
      this.goods = {};
      this.tableData1 = [];
      this.constitutes = [];
      this.dataSku1 = [];
    },
    downloadExcel() {
      let params = this.downloadData;
      findOrderListExcel(params).then(res => {
        if (res.code == "200") {
          window.open(res.data);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
